// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"index__Spinner___3hZuK","brand":"index__brand___3d_Rj"};